import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { TOAST_DURATION } from 'src/app/config/global.config';

interface SnackBarOptions {
  duration?: number;
  verticalPosition?: 'top' | 'bottom';
  horizontalPosition?: 'start' | 'center' | 'end' | 'left' | 'right';
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  show(
    message: string | string[],
    type: 'success' | 'error' | 'info' | 'warning',
    options: SnackBarOptions = {
      duration: TOAST_DURATION,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    }
  ) {
    const messages = Array.isArray(message) ? message : [message];
    const snackBarConfig: any = {
      data: { messages, type },
      panelClass: ['custom-snackbar'],
      duration: options.duration,
      verticalPosition: options.verticalPosition || 'top', // Allowed values are  'top' | 'bottom'
      horizontalPosition: options.horizontalPosition || 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right',
    };

    this.snackBar.openFromComponent(SnackbarComponent, snackBarConfig);
  }
}
